import React, { useEffect } from "react";
import ".././App.css";
import { auth } from "../firebase";

function Header() {
  const signOut = () => {
    auth.signOut();
    window.location.href = "/login";
  };

  const goTo = (path) => {
    window.location.href = path;
  };

  useEffect(() => {
    auth.onAuthStateChanged(() => {});
  }, []);

  return (
    <div>
      <nav
        className="main-header navbar navbar-expand navbar-light"
        style={{
          background: "linear-gradient(90deg, #1a2a4f, #0f3d3e)",
          padding: "0.5rem 1rem",
          boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
        }}
      >
        {/* LEFT */}
        <ul className="navbar-nav align-items-center">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#0">
              <i className="fas fa-bars header-icon" />
            </a>
          </li>

          <li className="nav-item brand-text">
            PREMIUM PMS
          </li>
        </ul>

        {/* CENTER MENU */}
        {/* <ul className="navbar-nav mx-auto header-menu">
          <li className="nav-item" onClick={() => goTo("/reservation")}>
            <span className="menu-item">
              <i className="fas fa-bed" />
              <small>Reserve Room</small>
            </span>
          </li>

          <li className="nav-item" onClick={() => goTo("/view-reservations")}>
            <span className="menu-item">
              <i className="fas fa-list" />
              <small>View Reservations</small>
            </span>
          </li>

          <li className="nav-item" onClick={() => goTo("/checkouts")}>
            <span className="menu-item">
              <i className="fas fa-door-open" />
              <small>Checkouts</small>
            </span>
          </li>

          <li className="nav-item" onClick={() => goTo("/pending-bookings")}>
            <span className="menu-item">
              <i className="fas fa-clock" />
              <small>Pending Reservations</small>
            </span>
          </li>

          <li className="nav-item" onClick={() => goTo("/advance-resevations")}>
            <span className="menu-item">
              <i className="fas fa-calendar-alt" />
              <small>Advance Reservations</small>
            </span>
          </li>

          <li className="nav-item" onClick={() => goTo("/self-report")}>
            <span className="menu-item">
              <i className="fas fa-chart-line" />
              <small>Self Report</small>
            </span>
          </li>

        
        </ul> */}

        {/* RIGHT */}
        <ul className="navbar-nav align-items-center ml-auto">
          <li className="nav-item">
            <button className="icon-btn" onClick={() => window.history.back()}>
              <i className="fas fa-backward" />
            </button>
          </li>

          <li className="nav-item">
            <button className="icon-btn" onClick={() => window.history.forward()}>
              <i className="fas fa-forward" />
            </button>
          </li>

          <li className="nav-item">
            <button className="icon-btn danger" onClick={signOut}>
              <i className="fas fa-sign-out-alt" />
            </button>
          </li>
        </ul>
      </nav>

      {/* STYLES */}
      <style>{`
        .header-icon {
          color: #fdf6e3;
          font-size: 18px;
        }

        .brand-text {
          color: #fdf6e3;
          font-weight: 700;
          font-size: 17px;
          margin-left: 10px;
        }

        .header-menu {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
        }

        .menu-item {
          color: #fdf6e3;
          padding: 6px 12px;
          border-radius: 12px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.3s ease;
          min-width: 80px;
        }

        .menu-item i {
          font-size: 16px;
          margin-bottom: 2px;
        }

        .menu-item small {
          font-size: 11px;
          letter-spacing: 0.5px;
        }

        .menu-item:hover {
          background: rgba(255,255,255,0.15);
          transform: translateY(-2px);
        }

        .icon-btn {
          background: none;
          border: none;
          color: #fdf6e3;
          font-size: 16px;
          margin-left: 10px;
          cursor: pointer;
        }

        .icon-btn.danger {
          color: #ff6b6b;
        }

        @media (max-width: 992px) {
          .header-menu {
            justify-content: center;
          }
        }

        @media (max-width: 768px) {
          .menu-item small {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}

export default Header;
